export type ReturnsExclusionsMessage = {
  title: string;
  message: string;
  categories: string[];
};

export const returnsExclusionsMessages: ReturnsExclusionsMessage[] = [
  {
    title: "Returns restrictions apply to this item",
    message:
      "Unless faulty, you can only return this item if unopened, unused and with the original seals or tags intact. This does not affect your statutory rights.",
    categories: [
      "6000460144",
      "600001812",
      "600001542",
      "300000004198",
      "90000360020",
      "60000922",
      "600001887",
      "700002430",
      "700002410",
      "50000296",
      "300000005268",
      "80000702",
      "90000360039",
      "60000246",
      "700008951",
      "20000450150",
    ],
  },
  {
    title: "Returns restrictions apply to this item",
    message:
      "You can only return this item if faulty or not as described. This does not affect your statutory rights.",
    categories: ["5904501226", "20000030030"],
  },
  {
    title: "Returns restrictions apply to this item",
    message:
      "Unless faulty or not a as described, you can only return this item if unopened and not redeemed. This does not affect your statutory rights.",
    categories: ["6000041", "9200010055"],
  },
];
